import React from 'react';

const AO = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_207"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_207)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#D0091E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8H21V15H0V8Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.31 9.58601C13.744 9.00401 14 8.28201 14 7.50001C14 6.03301 13.097 4.77701 11.817 4.25601L11.212 5.10301C12.246 5.41001 13 6.36701 13 7.50001C13 8.09401 12.793 8.64001 12.447 9.06801L9.00001 7.00001L11.696 9.69601C11.341 9.89001 10.933 10 10.5 10C9.66001 10 8.91701 9.58601 8.46401 8.95001L7.85901 9.79701C8.50001 10.534 9.44501 11 10.5 11C11.21 11 11.872 10.788 12.424 10.424L13 11L14 10L13.31 9.58601ZM9.00001 5.00001H10V6.00001H9.00001V5.00001Z"
        fill="#FAD800"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default AO;
